/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Preview_Label_ButtonInputs */

const en_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview recording`)
};

const fr_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prévisualiser l'enregistrement`)
};

const de_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschauaufnahme`)
};

const it_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima della registrazione`)
};

const ru_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр записи`)
};

const es_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de la grabación`)
};

const zh_cn2_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预览录制`)
};

const ja_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビュー録画`)
};

const hi_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग का पूर्वावलोकन करें`)
};

const pt_pt2_audio_recorder_preview_label_button = /** @type {(inputs: Audio_Recorder_Preview_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização da gravação`)
};

/**
* | output |
* | --- |
* | "Preview recording" |
*
* @param {Audio_Recorder_Preview_Label_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_preview_label_button = /** @type {((inputs?: Audio_Recorder_Preview_Label_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Preview_Label_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_preview_label_button(inputs)
	if (locale === "de") return de_audio_recorder_preview_label_button(inputs)
	if (locale === "it") return it_audio_recorder_preview_label_button(inputs)
	if (locale === "ru") return ru_audio_recorder_preview_label_button(inputs)
	if (locale === "es") return es_audio_recorder_preview_label_button(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_preview_label_button(inputs)
	if (locale === "ja") return ja_audio_recorder_preview_label_button(inputs)
	if (locale === "hi") return hi_audio_recorder_preview_label_button(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_preview_label_button(inputs)
	return en_audio_recorder_preview_label_button(inputs)
});